import { render } from "./SupportEng.vue?vue&type=template&id=1c664e18"
import script from "./SupportEng.vue?vue&type=script&lang=js"
export * from "./SupportEng.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__